import { ApolloLink, Observable } from '@apollo/client';
import { handleUnauthenticatedError } from './handleUnauthenticatedError';

const UNAUTHENTICATED_HTTP_STATUS = 401;

export const getErrorLink = getClient =>
  new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      const subscriber = {
        next: response => {
          return observer.next.bind(observer)(response);
        },
        error: networkError => {
          if (networkError.statusCode !== UNAUTHENTICATED_HTTP_STATUS) {
            return observer.error.bind(observer)(networkError);
          }

          const subscriber = {
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          };

          return handleUnauthenticatedError(networkError, {
            client: getClient(),
            subscriber,
            forward: () => forward(operation)
          });
        },
        complete: observer.complete.bind(observer)
      };

      forward(operation).subscribe(subscriber);
    });
  });
